/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\CompanyForm\CompanyForm.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday July 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 15th September 2023 01:12:19
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Styles from "Content/Contact/CompanyForm/CompanyForm.module.css";
import { Form, Col } from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import { ContactAddress } from "../AddressContact/AddressInterface";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";
import { TextField } from "@mui/material";

type CompanyFormProps = {
    onUpdate: Function
};

const CompanyForm = forwardRef((props: CompanyFormProps, ref) => {
    const [name, setName] = useState("");
    const [siren, setSiren] = useState("");
    const [phone, setPhone] = useState<string | undefined>();
    const addressRef = useRef<ContactAddress>();

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            Name: name,
            Siren: siren,
            Phone: phone,
            address: {
                address: addressRef.current?.address,
                city: addressRef.current?.city,
                postalCode: addressRef.current?.postalCode,
                state: addressRef.current?.state,
                country: addressRef.current?.country
            }
        }
    }, [name, siren, phone, addressRef.current]);

    return (
        <div className={`${Styles.formHolder}`}>
            <h3>{translator.decode("dynamic.company")}</h3>
            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={name ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.companyName")} size="small" onChange={(e) => {setName(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={siren ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.siren")} size="small" onChange={(e) => {setSiren(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    {translator.decode("dynamic.standard")}
                </Form.Label>
                <Col>
                    <PhoneInput autoComplete="on" value={phone} onChange={setPhone} defaultCountry="FR" />
                </Col>
            </Form.Group>
        </div>
    )
});

export default CompanyForm;
